import React from 'react';
import PropTypes from 'prop-types';
import { formatAlertsDate, formatNumberWithPostfix } from '@Utils/String';
import { Pill } from '@els/els-react--pill';

export default function CurrentAvailableResult({ selectedResultDate, selectedResultHits }) {
  if (!selectedResultDate) {
    return <span>No alert results</span>;
  }

  const selectedResultDateFormatted = formatAlertsDate(selectedResultDate);

  return (
    <>
      <span>{selectedResultDateFormatted}</span>
      {selectedResultHits && (
        <Pill pillColor="extended-blue-0" textColor="secondary" condensed className="u-els-margin-left-1o4">
          {formatNumberWithPostfix(selectedResultHits)} hits
        </Pill>
      )}
    </>
  );
}

CurrentAvailableResult.propTypes = {
  selectedResultDate: PropTypes.string,
  selectedResultHits: PropTypes.number,
};
